import { CMS, CMS_OPTIONS } from '@constants';
import { CMSIntegration } from './interfaces';
import { ContentstackIntegration } from './contentstack';

export const getCMSIntegration = (): CMSIntegration => {
  switch (CMS) {
  case CMS_OPTIONS.CONTENTSTACK:
    return new ContentstackIntegration();
  default:
    return new ContentstackIntegration();
  }
};
